import React, { Component } from "react";

import { connect } from "react-redux";
import Session from "../../utility/session";
import {
  loadProfileDetails,
  updateProfileDetails,
} from "../../Containers/Settings/actions";

import { profileHandleChange } from "../../common/actions";

import {
  profileGeneralValidators,
  updateValidators,
  initValidations,
} from "../../utility/validations";

import { ValidationSummary } from "../../utility/ValidationSummary";

import Overlay from "../../utility/overlay";
const mapStateToProps = (state) => ({
  profileInfo: state.settingsInfo.profileInfo,
});

class GeneralSettings extends Component {
  constructor(props) {
    super(props);
    this.state = { showErrorSummary: false };
    this.validators = profileGeneralValidators;

    // initValidations(this.validators);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }
  handleChange(event) {
    this.props.dispatch(
      profileHandleChange(event.target.name, event.target.value)
    );
    updateValidators(this.validators, event.target.name, event.target.value);
  }
  handleSubmit(event) {
    event.preventDefault();
    this.setState({ showErrorSummary: true });
    if (this.validators.errorSummary.length == 0) {
      this.props.dispatch(updateProfileDetails(this.props.profileInfo));
    }
  }
  handleCancel(event) {
    event.preventDefault();
    this.setState({ showErrorSummary: false });
    this.props.dispatch(
      loadProfileDetails({
        username: Session.getItem(Session.CURRENT_USER_NAME),
      })
    );
  }
  componentDidMount() {
    this.props.dispatch(
      loadProfileDetails({
        username: Session.getItem(Session.CURRENT_USER_NAME),
      })
    );
    updateValidators(this.validators, "name", this.props.name);
    updateValidators(this.validators, "CompanyName", this.props.CompanyName);
    this.setState({ showErrorSummary: true });
  }

  render() {
    return (
      <div
        role="tabpanel"
        className="tab-pane fade active in"
        id="tab_content1"
        aria-labelledby="home-tab"
      >
        {this.state.showErrorSummary ? (
          <ValidationSummary errorMsg={this.validators.errorSummary} />
        ) : null}

        {this.props.profileInfo.btnDisabled ? <Overlay /> : null}
        <form
          className="form-horizontal form-label-left"
          onSubmit={this.handleSubmit}
        >
          {/*
            <div className="item form-group">
            <label className="control-label col-md-3 col-sm-3 col-xs-12" htmlFor="email">
              Email
            </label>
            <div className="col-md-6 col-sm-6 col-xs-12" style={{padding: "8px 15px 0px"}}>{this.props.profileInfo.username}</div>
          </div>

          <div className="item form-group">
            <label className="control-label col-md-3 col-sm-3 col-xs-12" htmlFor="country">
              Country
            </label>
            <div className="col-md-6 col-sm-6 col-xs-12" style={{padding: "8px 15px 0px"}}>{this.props.profileInfo.country}</div>
          </div>
           */}

          <div className="item form-group">
            <label
              className="control-label col-md-3 col-sm-3 col-xs-12"
              htmlFor="email"
            >
              Email
            </label>
            <div className="col-md-6 col-sm-6 col-xs-12">
              <input
                className="form-control col-md-7 col-xs-12"
                data-validate-length-range="6"
                data-validate-words="2"
                name="email"
                maxLength="50"
                type="text"
                value={this.props.profileInfo.username}
                disabled={true}
              />
            </div>
          </div>

          <div className="item form-group">
            <label
              className="control-label col-md-3 col-sm-3 col-xs-12"
              htmlFor="name"
            >
              First Name <span className="required-label">*</span>
            </label>
            <div className="col-md-6 col-sm-6 col-xs-12">
              <input
                id="name"
                className="form-control col-md-7 col-xs-12"
                data-validate-length-range="6"
                data-validate-words="2"
                name="name"
                maxLength="50"
                type="text"
                onChange={this.handleChange}
                value={this.props.profileInfo.name}
              />
            </div>
          </div>

          <div className="item form-group">
            <label
              className="control-label col-md-3 col-sm-3 col-xs-12"
              htmlFor="name"
            >
              Last Name
            </label>
            <div className="col-md-6 col-sm-6 col-xs-12">
              <input
                type="text"
                id="lastname"
                className="form-control col-md-7 col-xs-12"
                data-validate-length-range="6"
                data-validate-words="2"
                name="lastname"
                maxLength="50"
                onChange={
                  this.handleChange // required
                }
                value={this.props.profileInfo.lastname}
              />
            </div>
          </div>

          <div className="item form-group">
            <label
              className="control-label col-md-3 col-sm-3 col-xs-12"
              htmlFor="name"
            >
              Company Name <span className="required-label">*</span>
            </label>
            <div className="col-md-6 col-sm-6 col-xs-12">
              <input
                type="text"
                id="CompanyName"
                className="form-control col-md-7 col-xs-12"
                data-validate-length-range="6"
                data-validate-words="2"
                name="CompanyName"
                maxLength="50"
                onChange={this.handleChange}
                value={this.props.profileInfo.CompanyName}
              />
            </div>
          </div>

          <div className="item form-group">
            <label
              className="control-label col-md-3 col-sm-3 col-xs-12"
              htmlFor="number"
            >
              Mobile Number
            </label>
            <div className="col-md-6 col-sm-6 col-xs-12">
              <input
                type="text"
                id="mobilenumber"
                name="mobilenumber"
                maxLength="14"
                className="form-control col-md-7 col-xs-12"
                onChange={
                  this.handleChange // required
                }
                value={this.props.profileInfo.mobilenumber}
              />
            </div>
          </div>

          <div className="item form-group">
            <label className="control-label col-md-3 col-sm-3 col-xs-12">
              Country
            </label>
            <div className="col-md-6 col-sm-6 col-xs-12">
              <input
                type="tel"
                id="country"
                name="country"
                data-validate-length-range="8,20"
                className="form-control col-md-7 col-xs-12"
                value={this.props.profileInfo.country}
                maxLength="100"
                disabled={true}
              />
            </div>
          </div>

          <div className="item form-group">
            <label className="control-label col-md-3 col-sm-3 col-xs-12">
              City
            </label>
            <div className="col-md-6 col-sm-6 col-xs-12">
              <input
                type="tel"
                id="city"
                name="city"
                data-validate-length-range="8,20"
                className="form-control col-md-7 col-xs-12"
                onChange={this.handleChange}
                value={this.props.profileInfo.city}
                maxLength="50"
              />
            </div>
          </div>

          <div className="item form-group">
            <label
              className="control-label col-md-3 col-sm-3 col-xs-12"
              htmlFor="telephone"
            >
              Address
            </label>
            <div className="col-md-6 col-sm-6 col-xs-12">
              <input
                type="tel"
                id="address"
                name="address"
                maxLength="200"
                data-validate-length-range="8,20"
                className="form-control col-md-7 col-xs-12"
                onChange={this.handleChange}
                value={this.props.profileInfo.address}
              />
            </div>
          </div>

          <div className="item form-group">
            <label
              className="control-label col-md-3 col-sm-3 col-xs-12"
              htmlFor="telephone"
            >
              Zipcode
            </label>
            <div className="col-md-6 col-sm-6 col-xs-12">
              <input
                type="tel"
                id="zipcode"
                name="zipcode"
                data-validate-length-range="8,20"
                className="form-control col-md-7 col-xs-12"
                onChange={this.handleChange}
                value={this.props.profileInfo.zipcode}
                maxLength="10"
              />
            </div>
          </div>

          <div className="ln_solid" />
          <div className="form-group">
            <div className="col-md-6 col-md-offset-3">
              <button
                type="clear"
                className="btn btn-default btn-block btn-lg"
                onClick={this.handleCancel}
              >
                Cancel
              </button>
              <button
                id="btnSave"
                type="submit"
                className="btn btn-primary btn-block btn-lg"
              >
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default connect(mapStateToProps)(GeneralSettings);



// WEBPACK FOOTER //
// ./src/components/Settings/GeneralSettings.js